import React, { PureComponent } from "react";
import { compose } from "redux";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import withImmutablePropsToJS from "with-immutable-props-to-js";

import * as actions from "../actions";
import {
  QUICK_VIEW_LOADER,
  getSearchParams,
} from "storefront/features/shared/utils";
import { getProduct } from "../selectors";
import { getMetaTags } from "../metaTags";
import QuickViewProduct from "./QuickViewProduct";
import { StyledModal } from "./ModalProductView.styled";
import { Helmet } from "storefront/features/shared";
import { WithLoader } from "storefront/features/shared/components/Loader";
import { getAuctionData } from "../../shared/components/Header/selectors";
import withPusherSubscription from "storefront/features/shared/components/SubscriptionPusher";

class ModalProductView extends PureComponent {
  static defaultProps = {
    pusherContext: "quick-view",
  };

  state = {
    show: true,
  };

  componentDidMount() {
    const { setFlagQuickViewIsOpened } = this.props;
    setFlagQuickViewIsOpened(true);
    this.fetchQuickViewProduct(this.props.location, true);
  }

  componentDidUpdate(prevProps) {
    const handle = this.props.location.pathname.split("/").pop();
    const prevHandle = prevProps.location.pathname.split("/").pop();
    const auctionId = getSearchParams(this.props.location.search, "auction_id");
    const prevAuctionId = getSearchParams(
      prevProps.location.search,
      "auction_id"
    );

    if (handle !== prevHandle || auctionId !== prevAuctionId) {
      this.fetchQuickViewProduct(this.props.location, true);
    }
  }

  componentWillUnmount() {
    const { setFlagQuickViewIsOpened, clearQuickViewProduct } = this.props;
    setFlagQuickViewIsOpened(false);
    clearQuickViewProduct();
  }

  fetchQuickViewProduct = (location, clearExisting = false) => {
    const { fetchProduct, clearQuickViewProduct } = this.props;
    const handle = location.pathname.split("/").pop();
    const auctionId = getSearchParams(location.search, "auction_id");

    if (clearExisting) {
      clearQuickViewProduct();
    }

    fetchProduct(handle, auctionId, QUICK_VIEW_LOADER);
  };

  handleClose = () => {
    const { history } = this.props;
    this.setState({ show: false });
    const pageNumber = getSearchParams(history.location.search, "page");
    const searchTitle = getSearchParams(history.location.search, "title");
    const buyingFormat = getSearchParams(history.location.search, "buying_format");
    const pathName = history.location.pathname;
    const regex = /^.*(?=(\/quick-view))/;
    const matchPathName = pathName.match(regex)[0];
    const homeLocation = pageNumber > 1 ? `/?page=${pageNumber}` : `/`;
    const pageLocation =
      pageNumber > 1 ? `${matchPathName}?page=${pageNumber}` : matchPathName;
    const characterIfPageExist = pageNumber > 1 ? "&" : "?";
    const searchLocation =
      searchTitle && buyingFormat
        ? `${pageLocation}${characterIfPageExist}title=${searchTitle}&buying_format=${buyingFormat}`
        : pageLocation;

    isEmpty(matchPathName)
      ? history.push(homeLocation)
      : history.push(searchLocation);
  };

  render() {
    const { show } = this.state;
    const {
      product,
      userAuctionData = {},
    } = this.props;
    const { vendor } = userAuctionData;
    const metaTags = getMetaTags(product);
    return (
      <>
        <Helmet metaTags={metaTags} />
        <StyledModal
          show={show}
          onHide={this.handleClose}
          size="lg"
          data-cy="modal-quick-view"
        >
          <Modal.Header closeButton className="border-0" />
          <Modal.Body className="show-grid p-0 p-sm-2 p-lg-4">
            <WithLoader
              loader={QUICK_VIEW_LOADER}
              forceLoading={isEmpty(product)}
            >
              <QuickViewProduct product={product} vendor={vendor} />
            </WithLoader>
          </Modal.Body>
        </StyledModal>
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  product: getProduct,
  userAuctionData: getAuctionData,
});

const mapDispatchToProps = (dispatch) => ({
  fetchProduct: (handle, auctionId, loader) => {
    dispatch(actions.fetchProductRequest({ handle, auctionId, loader }));
  },
  setFlagQuickViewIsOpened: (value) => {
    dispatch(actions.setFlagQuickViewIsOpened(value));
  },
  clearQuickViewProduct: () => {
    dispatch(actions.updateQuickViewProduct({}));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withImmutablePropsToJS,
  withPusherSubscription
)(ModalProductView);
